import React from "react";

const LandingPage = React.lazy(() => import("../routes/LandingPage"));
const LoginPage = React.lazy(() => import("../routes/LoginPage"));
const AccountPage = React.lazy(() => import("../routes/AccountPage"));
const ClientsPage = React.lazy(
  () => import("../routes/ClientsPage")
);
const ClientEditPage = React.lazy(
  () => import("../routes/ClientsPage/ClientEditPage")
);
const CryptoAccountingLandingPage = React.lazy(
  () => import("../routes/CryptoAccounting/CryptoAccountingLandingPage")
);
const CryptoAccountingPage = React.lazy(
  () => import("../routes/CryptoAccounting/CryptoAccountingPage")
);

interface RouteType {
  path: string;
  component: any;
  name: string;
  protected: boolean;
}

const routes: RouteType[] = [
  {
    path: "/login",
    component: LoginPage,
    name: "Login Page",
    protected: false,
  },
  {
    path: "",
    component: LandingPage,
    name: "Landing Page",
    protected: true,
  },
  {
    path: "/account",
    component: AccountPage,
    name: "Account Page",
    protected: true,
  },
  {
    path: "/clients",
    component: ClientsPage,
    name: "Clients Page",
    protected: true,
  },
  {
    path: "/clients/:id",
    component: ClientEditPage,
    name: "Client Edit Page",
    protected: true,
  },
  {
    path: "/crypto-accounting",
    component: CryptoAccountingLandingPage,
    name: "Crypto Accounting",
    protected: true,
  },
  {
    path: "/crypto-accounting/:id",
    component: CryptoAccountingPage,
    name: "Crypto Accounting Item",
    protected: true,
  },
];

export default routes;
